import { cn } from "@apex/shared";
import { Button } from "./ui/Button";
import { useWidget } from "../state";

export interface HeaderProps {
  className?: string;
}

export function Header({ className }: HeaderProps) {
  const { state, theme, goBack } = useWidget();

  const showBackButton =
    state.view === "configure" ||
    state.view === "summary" ||
    state.view === "error";

  const getTitle = () => {
    switch (state.view) {
      case "loading":
        return "Loading...";
      case "selection":
        return "Select a Product";
      case "configure":
        return state.selectedRootItem?.name || state.selectedRootItem?.code || "Configure";
      case "summary":
        return "Review Your Configuration";
      case "success":
        return "Quote Submitted";
      case "error":
        return "Something Went Wrong";
      default:
        return "Product Configurator";
    }
  };

  return (
    <header
      className={cn(
        "apex-flex apex-items-center apex-gap-3 apex-border-b apex-border-border apex-bg-background apex-px-6 apex-py-3",
        className
      )}
    >
      {showBackButton && (
        <Button
          variant="ghost"
          size="sm"
          onClick={goBack}
          className="apex-shrink-0 apex--ml-2"
          aria-label="Go back"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="m15 18-6-6 6-6" />
          </svg>
        </Button>
      )}

      {theme.logoUrl && (
        <img
          src={theme.logoUrl}
          alt=""
          className="apex-h-7 apex-w-auto apex-shrink-0"
          // Fail silently — a broken logo URL must not break the header layout.
          onError={(e) => {
            (e.currentTarget as HTMLImageElement).style.display = "none";
          }}
        />
      )}

      <h1 className="apex-flex-1 apex-text-lg apex-font-semibold apex-truncate apex-font-display">
        {getTitle()}
      </h1>

      {state.view === "configure" && state.selectedRootItem && (
        <div className="apex-text-sm apex-text-muted-foreground apex-hidden sm:apex-block">
          {state.selectedRootItem.code}
        </div>
      )}
    </header>
  );
}
